import React, { useEffect, useState } from 'react';
import AdminLayout from '../Componets/AdminLayout';
import DataTable from 'react-data-table-component';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AllocationDetails() {
  const apiUrl = process.env.REACT_APP_API_URL; // Base URL for the API
  const [data, setData] = useState([]); // State to store the data from the API
  const [filteredData, setFilteredData] = useState([]); // State to store the filtered data for the table
  const [count, setCount] = useState(0); // State to store the total answer sheet count
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [selectedFacultyIds, setSelectedFacultyIds] = useState([]); // State to store selected faculty IDs
  const [newAllocatedCounts, setNewAllocatedCounts] = useState({}); // State to store new allocated counts for each faculty
  const [facExamCount, setFacExamCount] = useState({}); // State to store new allocated counts for each faculty
  const [tableKey, setTableKey] = useState(Date.now()); // State to force reset the DataTable
  const token = localStorage.getItem('token'); // Retrieve the token from localStorage
  const location = useLocation(); // Hook to access the current location
  const { id, subjectId, subjectname } = location.state || {}; // Destructure id and subjectId from the location state
  const navigate = useNavigate(); // Use navigate hook from react-router-dom

  // cheking if the user is logged in or not then redirecting to home page
  useEffect(() => {
    const role = localStorage.getItem('role');

    if (role !== 'ADMIN') {
      // Adjusted comparison to match the role stored in localStorage
      navigate('/');
    }
    // eslint-disable-next-line
  }, []);

  // Function to fetch data from the API
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/answersheet/allocate/${id}/${subjectId}?allocationType=NORMAL`,
        {
          headers: {
            Authorization: token, // Set the authorization header
          },
        }
      );

      setFacExamCount({
        facultyCount: response?.data?.facultyCount,
        notAllocatedCount: response?.data?.notAllocatedCount,
      });
      const faculties = response.data.faculties || []; // Extract faculties array from the response
      setData(faculties); // Set the data state
      setFilteredData(faculties); // Set the filtered data state
      setCount(response.data.facultyCount); // Set the total answer sheet count state

      // Initialize new allocated counts from API response
      const initialNewAllocatedCounts = faculties.reduce((acc, faculty) => {
        acc[faculty.id] = faculty.notAllocatedCount || 0; // Assign API response value or 0
        return acc;
      }, {});
      setNewAllocatedCounts(initialNewAllocatedCounts);

      setLoading(false); // Set loading to false
    } catch (error) {
      console.error('Error fetching the data', error); // Log any errors
      setLoading(false); // Set loading to false
      toast.error(error.response?.data?.message); // Check if the error message exists
      error.response?.status === 401 && navigate('/');
    }
  };

  useEffect(() => {
    fetchData(); // Call the fetchData function
  }, [apiUrl, id, subjectId, token]); // Dependencies for the useEffect

  const handleAllocate = async () => {
    // Show a confirmation dialog before proceeding
    const isConfirmed = window.confirm(
      'Are you sure you want to allocate the answer sheets?'
    );

    if (isConfirmed) {
      try {
        // Prepare the list of faculty IDs and their corresponding new allocation counts
        const selectedFaculties = data.filter((faculty) =>
          selectedFacultyIds.includes(faculty.id)
        );

        const facultyIdsAndCounts = selectedFaculties.map((faculty) => ({
          facultyId: faculty.id,
          count: newAllocatedCounts[faculty.id] || 0, // Use the updated allocated count
        }));

        // Send the API request to save the allocation
        await axios.post(
          `${apiUrl}/api/answersheet/allocate/save`,
          {
            examId: id,
            subjectId: subjectId,
            facultyIds: facultyIdsAndCounts, // Send the list of faculty IDs with their allocated counts
          },
          {
            headers: {
              Authorization: token,
            },
          }
        );

        toast.success('Answer sheet allocated successfully');
        fetchData(); // Refresh the data after successful allocation

        // Reset selection and new allocations
        setSelectedFacultyIds([]); // Clear selected faculty IDs
        setNewAllocatedCounts({});
        setTableKey(Date.now()); // Update tableKey to reset selection
      } catch (error) {
        console.error('Error:', error);
        toast.error(error.response?.data?.message); // Check if the error message exists
        error.response?.status === 401 && navigate('/');
      }
    }
  };

  const handleRowSelected = (selectedRows, divedFacCount) => {
    const ids = selectedRows.selectedRows.map((row) => row.id); // Get selected faculty IDs
    setSelectedFacultyIds(ids);

    let AllocatedExamCounts = facExamCount?.notAllocatedCount; // Example allocation count (adjust as needed)
    const updatedAllocatedCounts = { ...newAllocatedCounts }; // Copy current allocation counts

    // If divedFacCount is 1: evenly divide the AllocatedExamCounts across faculties
    if (facExamCount?.facultyCount === 1) {
      const evenDivision = Math.floor(AllocatedExamCounts / ids.length);
      const remainder = AllocatedExamCounts % ids.length;

      // Distribute evenly and handle remainder
      ids.forEach((facultyId, index) => {
        updatedAllocatedCounts[facultyId] = evenDivision;
        if (index < remainder) {
          updatedAllocatedCounts[facultyId] += 1; // Add remainder to the first few faculties
        }
      });
    }

    // If divedFacCount is 2: allocate all to the first two faculties, others get 0
    else if (facExamCount?.facultyCount === 2) {
      ids.forEach((facultyId, index) => {
        if (index < 2) {
          updatedAllocatedCounts[facultyId] = AllocatedExamCounts; // Allocate to first two faculties
        } else {
          updatedAllocatedCounts[facultyId] = 0; // Ensure 0 allocation for others
        }
      });
    }

    // If a faculty exists in updatedAllocatedCounts but is not in ids, set their value to 0
    Object.keys(updatedAllocatedCounts).forEach((facultyId) => {
      if (!ids.includes(Number(facultyId))) {
        updatedAllocatedCounts[facultyId] = 0; // Set to 0 for faculties not in ids
      }
    });

    // Store the updated allocation counts
    setNewAllocatedCounts(updatedAllocatedCounts);
    console.log(updatedAllocatedCounts, 'Updated Allocated Counts');
  };

  // Define the columns for the DataTable
  const columns = [
    {
      name: 'No',
      selector: (row, index) => index + 1, // Add a serial number column
      width: '50px',
      center: 'true', // Correct the "center" property
    },
    {
      name: 'Faculty Name',
      selector: (row) => row.name, // Select the faculty name from the row data
      sortable: true,
    },
    {
      name: 'Allocated',
      selector: (row) => row.allocatedCount, // Select the answer sheet count from the row data
      center: 'true',
      width: '170px',
    },
    {
      name: 'New Allocated',
      cell: (row) => (
        <input
          type="number"
          onWheel={(e) => e.target.blur()}
          className="form-control"
          value={newAllocatedCounts[row.id] || 0}
          onChange={(e) => handleNewAllocatedChange(row.id, e.target.value)}
          min="0"
        />
      ),
      center: 'true',
      width: '170px',
    },
  ];

  // Handler to update the new allocated count
  const handleNewAllocatedChange = (facultyId, value) => {
    setNewAllocatedCounts((prevCounts) => ({
      ...prevCounts,
      [facultyId]: parseInt(value, 10) || 0, // Ensure the value is an integer
    }));
  };
  // Function to handle the search input change
  const handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase(); // Get the search term and convert to lowercase
    const filtered = data.filter((item) =>
      item.name.toLowerCase().includes(searchTerm)
    ); // Filter the data based on the search term
    setFilteredData(filtered); // Set the filtered data state
  };

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle ">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                {' '}
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li
                className="breadcrumb-item  cursor-pointer"
                onClick={() => navigate('/ListExam')}
              >
                View Exam
              </li>
              <li
                className="breadcrumb-item  cursor-pointer "
                onClick={() => navigate(-1)}
              >
                Exam Subjects
              </li>
              <li className="breadcrumb-item active">
                AnswerSheet Allocation Details of {subjectname} ({count})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <div className="datatable-top">
          <div className="datatable-search">
            <input
              className="form-control"
              type="search"
              name="search"
              placeholder="Search"
              title="Search within table"
              onChange={handleSearch} // Add the onChange handler
            />
          </div>
        </div>
        <DataTable
          key={tableKey} // Add the key to force reset
          columns={columns}
          selectableRows
          onSelectedRowsChange={handleRowSelected} // Add the onSelectedRowsChange handler
          data={filteredData} // Use filteredData for the table
          progressPending={loading}
          className="custom-table"
        />

        <div className="text-end mt-3">
          <button
            type="button"
            onClick={handleAllocate}
            className="btn btn-primary mx-2"
          >
            <i className="bi bi-check2-circle"></i> Allocate
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-x-circle"></i> Cancel
          </button>
        </div>

        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </main>
    </AdminLayout>
  );
}
